import { FC } from "react";
import { ProviderMapResults } from "@app/projects/results/common/mapping";
import { ProviderBadgeStyle } from "@app/projects/enumerators";
import ProviderNetworkTypeBadge from "@app/shared/ProviderNetworkTypeBadge";
import { useProviderGapStatusDecorator } from "@app/shared/providers/utils";
import { formatPercent } from "@app/projects/zip-projects/maps/providerMetricFormat";
import { ZipProviderCard } from "@app/projects/zip-projects/maps/components/ZipProviderCard";
import ProviderActionStatusBadge from "@app/shared/ProviderActionStatusBadge";

export interface ZipImpactProviderCardProps {
  provider: ProviderMapResults;
  isSelected: boolean;
  passPercentage: number | null;
  onClick: (provider: ProviderMapResults) => void;
}

/** Provider Listing Out-Of-Network Providers tab card */
export const ZipImpactProviderCard: FC<ZipImpactProviderCardProps> = ({ provider, isSelected, passPercentage, onClick }) => {
  const getProviderGapStatusDecorator = useProviderGapStatusDecorator();
  const gapStatus = getProviderGapStatusDecorator(
    provider.gainsPercent ?? 0,
    provider.impactsPercent ?? 0,
    provider.servesPercent,
    passPercentage ?? 0,
  );

  return (
    <ZipProviderCard
      provider={provider}
      isSelected={isSelected}
      statusClassName={gapStatus}
      onClick={onClick}
    >
      <div className="d-flex flex-row">
        <p className="me-3"><strong>Serves:</strong> {formatPercent(provider.servesPercent)}</p>
        <p className="me-3"><strong>Gains:</strong> {formatPercent(provider.gainsPercent)}</p>
        <p><strong>Impact:</strong> {formatPercent(provider.impactsPercent)}</p>
      </div>
      <div className="d-flex flex-row">
        <div className="me-2">
          <ProviderNetworkTypeBadge badgeStyle={ProviderBadgeStyle.Outline} providerNetworkType={provider.providerNetworkType} />
        </div>
        <ProviderActionStatusBadge
          badgeStyle={ProviderBadgeStyle.Outline}
          status={provider.scenarioModelProviderStatus}
          hideWhenNullActionStatus={true}
        />
      </div>
    </ZipProviderCard>
  );
};

export default ZipImpactProviderCard;
